import { LayoutGrid, MapPin } from 'lucide-react'
import type { Fact } from '@/components/ui/facts'

/**
 * A venue's facts, in the order every venue surface shows them: where it is,
 * then how many spaces it has.
 *
 * One list for the venue cards, the dashboard's header and the settings
 * header, so a venue reads the same wherever it is met — the dashboard used to
 * show only the address and the settings page both, and a venue without an
 * address showed neither the same way twice.
 */
export function venueFacts<S>(venue: { address: string | null; spaces: readonly S[] }): Fact[] {
  const count = venue.spaces.length
  return [
    { icon: <MapPin />, label: 'Address', value: venue.address, empty: 'No address yet' },
    {
      icon: <LayoutGrid />,
      label: 'Spaces',
      value: count > 0 ? `${String(count)} ${count === 1 ? 'space' : 'spaces'}` : null,
      empty: 'No spaces yet',
    },
  ]
}
